import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/ForgotPassword.css";
import loginImage from "../assets/login.jpg";
import { API_BASE_URL } from "../config/api";

const ForgotPassword = () => {
  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimmedValue = emailOrPhone.trim();

    const res = await fetch(`${API_BASE_URL}/auth/forgot-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: trimmedValue }),
    });

    const data = await res.json();

    if (res.ok) {
      navigate(`/verify-code?email=${encodeURIComponent(trimmedValue)}`);
    } else {
      setError(data.message || "Erreur lors de l'envoi");
    }
  };

  return (
    <div className="reset-container">
      <div className="reset-left">
       <img src={loginImage} alt="Login" className="login-image" />
        <div className="reset-text">
          <h2>Espace Administrateur</h2>
          <p>
            Gérez vos prestations, vos locations et vos utilisateurs depuis votre espace
            administrateur.
          </p>
        </div>
      </div>

      <div className="reset-right">
        <h1 className="logo">
          <span className="blue">Waa</span><span className="black">Go</span>
        </h1>
        <h2>Mot de passe oublié</h2>
        <p>Saisissez votre e-mail ou numéro de téléphone pour récupérer votre mot de passe.</p>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="exemple@mail.com"
            value={emailOrPhone}
            onChange={(e) => setEmailOrPhone(e.target.value)}
            required
          />
          <button type="submit" className="submit-btn">Envoyer</button>
        </form>

        {error && <p style={{ color: "red" }}>{error}</p>}

        <Link to="/login" className="back-link">Se connecter</Link>
      </div>
    </div>
  );
};

export default ForgotPassword;
